import React, { useState, createContext, useEffect } from 'react';
import utilsPageSections from '../_Utils/utilsPageSections';


export const SectionsContext = createContext();

export const SectionsContextProvider = props => {
    const [Sections, setSections] = useState([]);

    useEffect(() => {
        setIt()
    }, [])

    const setIt = async() => {
        let tempo = await utilsPageSections.allPgsSectionsFull();
        let sorted = [...tempo].sort((a, b) => {
            let orderA = (a.orderSection != null) ? a.orderSection : Number.MAX_SAFE_INTEGER;
            let orderB = (b.orderSection != null) ? b.orderSection : Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
        });
        setSections(sorted)
    }


    useEffect(() => {
    }, [Sections])


    return (
        <SectionsContext.Provider value={[Sections, setSections]}>
            {props.children}
        </SectionsContext.Provider>
    )
}

